import { render, staticRenderFns } from "./Order_list.vue?vue&type=template&id=34c8c82f&scoped=true&"
import script from "./Order_list.vue?vue&type=script&lang=js&"
export * from "./Order_list.vue?vue&type=script&lang=js&"
import style0 from "./Order_list.vue?vue&type=style&index=0&id=34c8c82f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c8c82f",
  null
  
)

export default component.exports